import styled from 'styled-components';

export const TextLoader = styled.div`
  	font-family: Poppins, Heltica, Arial, sans-serif;
   	display: flex;
    align-items: center;
    justify-content: center;
    height: 90vh;
    color: #999;
    span{
    	font-size: 24px;
    }
`;
